<template>
        <b-container class="wrapper" fluid>
            <b-row class="section body blue" align-h="center">
                <b-col cols="12" md="11" xl="8">
                    <b-row align-h="between">
                        <b-col class="left" cols="12" md="6" xl="6">
                            <a href="https://ozmo.mx"><img class="logo" alt="Ozmo logo" src="../../assets/ozmo_blanco.svg"></a>
                        </b-col>
                        <b-col class="right d-none d-sm-block" md="6" xl="6">
                            <a href="https://www.linkedin.com/company/ozmo-futures-design" target="_blank"><div class="icon"><font-awesome-icon :icon="['fab', 'linkedin-in']" /></div></a>
                            <a href="https://twitter.com/OzmoFutures" target="_blank"><div class="icon"><font-awesome-icon :icon="['fab', 'twitter']" /></div></a>
                            <a href="https://www.instagram.com/ozmofutures/" target="_blank"><div class="icon"><font-awesome-icon :icon="['fab', 'instagram']" /></div></a>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" md="11" xl="8">
                    <b-row>
                        <b-col cols="12" md="12" xl="12">
                            <p></p>
                            <p>En el caos debemos actuar<br>de forma rápida y decidida.<br><span class="footnote">Dave Snowden</span></p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="9" md="9" xl="9">
                            <h3>¿Cómo blindar a tu empresa ante la crisis?</h3>
                        </b-col>
                    </b-row>
                    <b-row align-v="center">
                        <b-col cols="12" md="6" xl="6">
                            <p>Entendemos que ya sabes que el mundo está cambiando debido al COVID-19.</p>
                            <p>No estamos aquí para contarte la misma historia que has seguido durante semanas a través de diversos espacios. Estamos aquí para mirar más allá del panorama general.</p>
                        </b-col>
                        <b-col cols="12" md="6" xl="6">
                            <div class="mask2"></div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="12" xl="12">
                            <h3>Cambia el enfoque de tu empresa</h3>
                            <p>En Ozmo hemos desarrollado una metodología enfocada a la transformación estratégica de tu empresa a través del fortalecimiento interno y la creación de valor al mercado.</p>
                            <p>Es un gran momento fortalecer la continuidad de tu empresa y encontrar nuevas oportunidades de negocio.</p>
                            <p>Completa el diagnóstico y nos pondremos en contacto contigo a la brevedad para accionar estrategias desde dos distintos frentes: dentro y fuera de tu organización.</p>
                            <p><b-button @click="launch" class="ozmo-btn">Realizar diagnóstico</b-button></p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="12" xl="12">
                            <h3>¿En qué áreas te podemos ayudar?</h3>
                        </b-col>
                        <b-col cols="12" md="4" xl="4">
                            <b-row class="ozmo-bullet" align-v="center" align-h="center">
                                <b-col cols="3" md="3" xl="3"><div class="head gray mx-auto">01</div></b-col>
                                <b-col cols="9" md="9" xl="9" class="text">Cultura</b-col>
                            </b-row>
                            <p>Impulsando la transformación cultural dentro de la empresa.</p>
                        </b-col>
                        <b-col cols="12" md="4" xl="4">
                            <b-row class="ozmo-bullet" align-v="center" align-h="center">
                                <b-col cols="3" md="3" xl="3"><div class="head red mx-auto">02</div></b-col>
                                <b-col cols="9" md="9" xl="9" class="text">Management</b-col>
                            </b-row>
                            <p>Alineando la forma de actuar de los líderes con los objetivos de la empresa.</p>
                        </b-col>
                        <b-col cols="12" md="4" xl="4">
                            <b-row class="ozmo-bullet" align-v="center" align-h="center">
                                <b-col cols="3" md="3" xl="3"><div class="head green mx-auto">03</div></b-col>
                                <b-col cols="9" md="9" xl="9" class="text">Innovación</b-col>
                            </b-row>
                            <p>Habilitando la adaptación y evolución de las empresas para su transformación.</p>
                        </b-col>
                        <b-col cols="12" md="12" xl="12">
                            <p>Ozmo es una consultora de transformación estratégica y queremos ayudarte a que te adaptes a esta nueva normalidad.</p>
                        </b-col>
                    </b-row>
                    <b-row align-v="center">
                        <b-col class="d-none d-sm-block" md="4" xl="4">
                            <div class="mask mx-auto"></div>
                        </b-col>
                        <b-col class="callToAction" cols="12" md="8" xl="8">
                            <h5>“No habrá regreso a la vida real. Los hábitos de consumo van a ser totalmente diferentes.” </h5>
                            <p class="footnote">- Directivo de tienda departamental</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="12" xl="12">
                            <h6>Hacemos que el cambio ocurra por <span class="vd">diseño</span>, no por <span class="vd">casualidad</span>.</h6>
                            <p><b-button @click="launch" class="ozmo-btn">Realizar diagnóstico</b-button></p>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
</template>

<script>

import * as typeformEmbed from '@typeform/embed';

import { eventBus } from '../../main'

export default {
    data() {
        return{}
    },
    metaInfo() {
        return {
            title: 'MTA | Ozmo ',
            meta: [
                {name: 'description', content: 'Mindset, Tactics, Action'},
+               {name: 'keywords', content: 'MTA, Mindset, Tactics, Action, consultora en innovación estratégica, consultora de innovación, agencia de transformación estratégica, consultora de cultura organizacional, consultoría en transformación para empresas, consultoría en cultura organizacional, proveedores de design thinking, agencias de investigación de usuarios, talleres para diseñar experiencias, consultoras con experiencia en área de capital humano, consultoras en innovación con experiencia sector financiero, agencia de innovación empresarial'},
                {name: 'robots', content: 'index,follow'},
                {name: 'viewport', content: 'width=device-width,initial-scale=1,user-scalable=no' },
                {charset: 'utf-8' },
                {property: 'og:title', content: 'MTA | Ozmo'},
+               {property: 'og:site_name', content: 'Ozmo | Diseño de futuros'},
+               {property: 'og:description', content: 'Mindset, Tactics, Action'},
                {property: 'og:type', content: 'website'},
                {property: 'og:image', content: 'https://s3-us-west-2.amazonaws.com/cdn.ozmo.mx/ozmo_coral.png'}
            ]
        }
    },
    methods: {
        goto(navigation) {
            eventBus.$emit('gotoNavigation', navigation)
        },
        launch() {
            typeformEmbed.makePopup(
                'https://app.involve.me/ozmo-futures/mta-quiz',
                {
                    mode: 'drawer_right',
                    autoOpen: true,
                    autoClose: 15,
                    hideScrollbars: true,
                    onSubmit: function () {}
                }
                )
        }
    }
}
</script>

<style lang="stylus" scoped>


/***********************
    COLORING STYLES
***********************/

.blue
    --template-color $ozmo-green
    background-color #444EE6

    .icon
        background-color #444EE6
        color #ffffff

    h1,h2,h3,h2 .bold
        color $ozmo-green
    h4    
        color #FFFFFF
    p
        color #ffffff

        .footnote
            color #ffffff

        .colored
            color $ozmo-green

        .bold
            color #ffffff

    .ozmo-bullet
        .text
            color #FFFFFF

    .ozmo-btn
        border 2px solid $ozmo-green
        background-color $ozmo-green
        color $ozmo-gray

    .mask2, .mask3 
        box-shadow 175px 0px 0px $ozmo-green

.red
    --template-color $ozmo-blue
    background-color $ozmo-coral

    .logo
        filter brightness(0) invert(1)

    .icon
        background-color #FFFFFF
        color $ozmo-coral

    h1,h2,h2 .bold
        color #FFFFFF

    p
        color #FFFFFF

        .colored
            color $ozmo-blue

        .bold
            color #FFFFFF

    .ozmo-bullet
        .text
            color #FFFFFF

    .ozmo-btn
        border 2px solid #FFFFFF
        background-color #FFFFFF
        color $ozmo-coral

    .mask2
        box-shadow 175px 0px 0px $ozmo-blue



.gray
    --template-color $ozmo-coral
    background-color $ozmo-gray

    .logo
        filter brightness(0) invert(1)

    .icon
        background-color #FFFFFF
        color $ozmo-gray

    h1,h2,h2 .bold
        color #FFFFFF

    p
        color #FFFFFF

        .colored
            color $ozmo-green

        .bold
            color #FFFFFF

    .ozmo-bullet
        .text
            color #FFFFFF

    .ozmo-btn
        border 2px solid #FFFFFF
        background-color #FFFFFF
        color $ozmo-gray

    .mask2
        box-shadow 175px 0px 0px $ozmo-coral





/***********************
    TEMPLATE STYLES
***********************/

.wrapper
    width 100vw
    height 100vh
    overflow-x hidden
    overflow-y scroll

.logo
    width 144px

.icon
    width 32px
    height 32px
    border-radius 32px
    line-height 32px
    background-color $ozmo-coral
    text-align center
    margin-left 2rem
    float right
    txt_style($worksans-m, 20px, #FFFFFF)

.mask
    margin-top 10rem
    width 250px
    height 250px
    border-radius 300px
    background-image url('../../assets/landings/mta/plantas.jpg')
    background-repeat no-repeat
    background-position center
    background-size 400px

.mask2
    width 350px
    height 350px
    border-radius 350px
    background-image url('../../assets/landings/mta/bienvenidos.jpg')
    background-repeat no-repeat
    background-position center
    background-size 400px

.mask3
    width 350px
    height 350px
    border-radius 350px
    background-image url('../../assets/landings/mta/grupo.jpg')
    background-repeat no-repeat
    background-position center
    background-size 550px  

.ozmo-bullet
    margin-top 5rem

    .head
        width 63px
        height 63px
        line-height 63px
        border-radius 57px
        text-align center
        txt_style($archia-m, 16px, #FFFFFF)

    .head.blue
        background-color $ozmo-blue

    .head.green
        background-color $ozmo-green

    .text
        txt_style($worksans-b, 18px, $ozmo-coral)

.body
    padding 10rem 0

img
    width 100%

h1
    margin-top 10rem
    txt_style($archia-m, 48px, $ozmo-coral)

h2
    margin-top 10rem
    txt_style($archia-r, 48px, $ozmo-coral)

    .bold
        txt_style($archia-m, 48px, $ozmo-coral)
h3
    margin-top 10rem
    txt_style($archia-r, 40px, $ozmo-coral)

    .bold
        txt_style($archia-m, 40px, $ozmo-coral)  
h4
    margin-top 8rem
    txt_style($archia-r, 24px, $ozmo-coral)  

h5
    margin-top 8rem
    txt_style($archia-r, 28px, #FFFFFF)

h6
    margin-top 8rem
    txt_style($archia-r, 30px, #FFFFFF)                      

    .vd
         txt_style($archia-r, 30px, $ozmo-green) 
p
    margin-top 5rem
    txt_style($worksans-r, 18px, $ozmo-gray)

    .colored
        txt_style($worksans-r, 18px, $ozmo-blue)

    .bold
        txt_style($worksans-b, 18px, #ffffff)

.footnote
        txt_style($worksans-r, 16px, $ozmo-gray)

.ozmo-btn
    txt_style($worksans-r, 22px, $ozmo-coral)
    line-height 44px


@media (min-width 768px) and (max-width 1200px)
    .mask
        width 200px
        height 200px
        background-size 300px

    .mask2
        width 300px
        height 300px
        background-size 600px
        box-shadow 150px 0 0 var(--template-color) !important
    
    .mask3
        width 300px
        height 300px
        background-size 600px
        box-shadow 150px 0 0 var(--template-color) !important

@media (max-width 767px)

    .mask2
        width 200px
        height 200px
        background-size 400px
        margin 10rem auto 0 auto
        box-shadow 100px 0 0 var(--template-color) !important
        position relative
        left -50px

    .mask3
        width 200px
        height 200px
        background-size 400px
        margin 10rem auto 0 auto
        box-shadow 100px 0 0 var(--template-color) !important
        position relative
        left -50px    

    h1,h2,h2,h3,h4,h5,h3 .bold, h3.colored
        font-size 32px

    p, p .colored, p .bold
        font-size 16px
    .footnote
        font-size 14px  

    .callToAction
        text-align center

    .ozmo-btn
        txt_style($worksans-r, 20px, $ozmo-coral)   

@media (max-width 320px)

    .mask2
        width 200px
        height 200px
        background-size 400px
        margin 10rem auto 0 auto
        box-shadow 100px 0 0 var(--template-color) !important
        position relative
        left -50px

    .mask3
        width 200px
        height 200px
        background-size 400px
        margin 10rem auto 0 auto
        box-shadow 100px 0 0 var(--template-color) !important
        position relative
        left -50px    

    h1,h2,h2,h3,h4,h5,h3 .bold, h3.colored
        font-size 30px

    p, p .blue, p .bold, p .colored
        font-size 14px
    .footnote
        font-size 12px  

    .callToAction
        text-align center

    .footnote
        font-size 12px

    .ozmo-btn
        txt_style($worksans-r, 18px, $ozmo-coral)    

</style>